import type { GridBaseProps } from "@repo/ui";

import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, ButtonColor, ButtonSize, Column, GridPreLoaded, OriginalTimezoneDateColumn } from "@repo/ui";
import { useMemo, useState } from "react";

import type { ITrainerCertification } from "../../../models/MVCStateSpecificTraining";

import { useTrainingApi, useTrainingQueries } from "../../../api/trainingApi";
import { DeleteAlertDialog } from "../../../components/deleteAlertDialog";
import style from "./style.module.scss";

export default function TrainerCertificationGridBasic(props: GridBaseProps<ITrainerCertification>) {
	const { useTrainerCertificationsQuery } = useTrainingQueries();
	const { deleteTrainerCertification } = useTrainingApi();
	const { data, loaded, clearQuery } = useTrainerCertificationsQuery();

	const [deleteTrainerCertificationId, setDeleteTrainerCertificationId] = useState<number | null>(null);

	const columns = useMemo(
		() =>
			[
				new Column("", "id").withFormat(renderDeleteButton),
				new OriginalTimezoneDateColumn("Phase 1", "phase1").dateOnly(),
				new OriginalTimezoneDateColumn("Phase 2", "phase2").dateOnly(),
				new OriginalTimezoneDateColumn("Phase 3", "phase3").dateOnly(),
				new Column("Trainer", "trainerName"),
				new Column("State", "stateName"),
			] as Column<ITrainerCertification>[],
		[],
	);

	function deleteButtonClick(id: number) {
		setDeleteTrainerCertificationId(id);
	}

	async function confirmDelete() {
		if (deleteTrainerCertificationId) {
			await deleteTrainerCertification(deleteTrainerCertificationId);
			await clearQuery();
			setDeleteTrainerCertificationId(null);
		}
	}

	function renderDeleteButton(customerActionId: number) {
		return (
			<div className={style.editButtons}>
				<Button
					color={ButtonColor.Green}
					onClick={() => deleteButtonClick(customerActionId)}
					size={ButtonSize.medium}
				>
					<FontAwesomeIcon icon={faTimes} size="lg" />
					Delete
				</Button>
			</div>
		);
	}

	return (
		<>
			<GridPreLoaded
				title={null}
				id="trainerCertificationGrid"
				pageSize={3}
				columns={columns}
				values={data?.data ?? []}
				loading={!loaded}
				getData={clearQuery}
				{...props}
			/>
			<DeleteAlertDialog
				isOpen={!!deleteTrainerCertificationId}
				onClose={() => setDeleteTrainerCertificationId(null)}
				onConfirm={confirmDelete}
				title="Delete Training"
				description="Are you sure you want to delete this training?"
			/>
		</>
	);
}
